import { assertUnreachable } from '../../helpers/TypescriptHelpers';
import { IContentAndLuidInfo } from '../../mappers/DatabaseAndTableMapper';
import { JsonRestApiRequestConfig, makeJsonRestApiRequest } from '../../services/RestApiService';
import { TaggableCatalogTypes, TaggableCatalogTypesRestApiVersion } from './CatalogContentTags';
import { SetCatalogContentTagsParam } from './setCatalogContentTags';

export type DeleteTagsResponse = {}[];

export type DeleteCatalogContentTagsParam = Pick<IContentAndLuidInfo, 'luid' | 'tags'> & TaggableCatalogTypes;

export async function deleteCatalogContentTags(item: SetCatalogContentTagsParam): Promise<DeleteTagsResponse | void> {
  if (!item.tags || item.tags.length < 1) {
    return;
  }

  switch (item.contentType) {
    case 'database':
      return deleteDatabaseTags(item);
    case 'table':
      return deleteTableTags(item);
    default:
      assertUnreachable(item.contentType);
  }
}

function deleteDatabaseTags(item: SetCatalogContentTagsParam) {
  return Promise.all(item.tags.map(t => {
    const config: JsonRestApiRequestConfig = {
      restApiVersion: TaggableCatalogTypesRestApiVersion,
      serverWideRequest: false,
      httpMethod: 'DELETE',
      endpoint: `databases/${item.luid}/tags/${encodeURIComponent(t)}`,
    };

    return makeJsonRestApiRequest<{}, {}>({ config, request: {} });
  }));
}

function deleteTableTags(item: SetCatalogContentTagsParam) {
  return Promise.all(item.tags.map(t => {
    const config: JsonRestApiRequestConfig = {
      restApiVersion: TaggableCatalogTypesRestApiVersion,
      serverWideRequest: false,
      httpMethod: 'DELETE',
      endpoint: `tables/${item.luid}/tags/${encodeURIComponent(t)}`,
    };

    return makeJsonRestApiRequest<{}, {}>({ config, request: {} });
  }));
}
